<template>
  <table class="table-sm" style="width: 100%; background: #95b4ff30">
    <thead>
      <tr>
        <th nowrap class="text-center border-gray" width="28%">Campo</th>
        <th nowrap class="text-center border-gray" width="36%">Valor antigo</th>
        <th nowrap class="text-center border-gray" width="36%">Valor novo</th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="(value, index) in displayFields" :key="index">
        <td :title="audit.id" class="border-gray">
          {{ getFieldLabel(index, audit.type) }}
        </td>
        <td class="text-center border-gray">
          {{
            typeof audit.old_values != 'undefined' && index != 'change_reason'
              ? getValue(audit.old_values[index], index)
              : '-'
          }}
        </td>
        <td class="text-center border-gray">
          {{ audit.event != 'deleted' && value != 'undefined' ? getValue(value, index) : '-' }}
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script>
export default {
  name: 'CustomerGroupHistoryValuesTable',
  props: {
    audit: {
      type: Object,
    },
  },
  methods: {
    getFieldLabel(index, type) {
      const defaultFields = {
        description: 'Descrição',
        document: 'Documento',
        customer_id: 'Cliente',
      };

      return defaultFields[index] + (type ? ` - ${type}` : '');
    },
    getValue(value, index) {
      if (
        typeof value !== 'undefined' &&
        value != '0000-00-00' &&
        (index == 'finish' || index == 'start' || index == 'grace_date')
      ) {
        return value ? this.$options.filters.date(value) : '-';
      }

      return value || '-';
    },
  },
  computed: {
    displayFields() {
      let list = [];
      const filterFields = ['group_id', 'id'];
      if (this.audit.event == 'deleted') {
        list = this.audit.old_values;
      } else {
        list = this.audit.new_values;
      }
      for (const [key, value] of Object.entries(list)) {
        if (filterFields.includes(key)) {
          delete list[key];
        }
      }
      return list;
    },
  },
};
</script>
